/**
 * NOTE: This file is used to overwrite the default theme because of the portals config.
 * DO NOT EDIT THIS FILE.
 */
export default {}